import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { type SxProps } from '@mui/material/styles';

import { useFormattedBookingDetails } from 'reservations/booking/hooks/useFormattedBookingDetails';

interface Props {
  showStrikeThrough: boolean;
  omitName?: boolean;
  sxOverride?: SxProps;
}

export const BookingDetails = ({
  showStrikeThrough,
  omitName = false,
  sxOverride = {}
}: Props) => {
  const { fullName, formattedDateAndTime, numberOfGuests } =
    useFormattedBookingDetails();
  const sx = { fontWeight: 600, ...sxOverride };

  return (
    <Grid item>
      {!omitName && <Typography sx={sx}>{fullName}</Typography>}
      <Typography
        sx={{
          ...sx,
          ...(showStrikeThrough && { textDecoration: 'line-through' })
        }}
      >
        {formattedDateAndTime}
      </Typography>
      <Typography
        sx={{
          ...sx,
          ...(showStrikeThrough && { textDecoration: 'line-through' })
        }}
      >
        {numberOfGuests}
      </Typography>
    </Grid>
  );
};
